import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './ReactionTime.css';

const ReactionTime = () => {
  const [state, setState] = useState('waiting'); // waiting, ready, go, result
  const [reactionTime, setReactionTime] = useState(null);
  const [bestTime, setBestTime] = useState(null);
  const [attempts, setAttempts] = useState([]);
  const startTimeRef = useRef(null);
  const timeoutRef = useRef(null);

  const startTest = () => {
    setState('ready');
    const delay = Math.random() * 3000 + 2000;
    
    timeoutRef.current = setTimeout(() => {
      setState('go');
      startTimeRef.current = Date.now();
    }, delay);
  };

  const handleClick = () => {
    if (state === 'waiting') {
      startTest();
    } else if (state === 'ready') {
      clearTimeout(timeoutRef.current);
      setState('waiting');
      alert('Too early! Wait for cyan.');
    } else if (state === 'go') {
      const time = Date.now() - startTimeRef.current;
      setReactionTime(time);
      setAttempts(a => [...a, time]);
      if (!bestTime || time < bestTime) {
        setBestTime(time);
      }
      if (time < 200) {
        setState('excellent');
      } else if (time < 300) {
        setState('good');
      } else {
        setState('result');
      }
    } else if (state === 'result' || state === 'excellent' || state === 'good') {
      setState('waiting');
    }
  };

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  const avgTime = attempts.length > 0 
    ? Math.round(attempts.reduce((a, b) => a + b, 0) / attempts.length)
    : null;

  return (
    <div className="game-container">
      <div className="game-header">
        <h1 className="game-title-header">⚡ Reaction Time Tester</h1>
        <div className="game-instructions">
          Click when the screen turns green!
        </div>
      </div>

      <div className="game-board">
        <div className="score-display">
          {bestTime && `Best: ${bestTime}ms`}
          {avgTime && ` | Avg: ${avgTime}ms`}
        </div>
        
        <div className="game-play-area">
          <div 
            className={`reaction-area ${state}`}
            onClick={handleClick}
          >
            {state === 'waiting' && (
              <div className="reaction-message">Click to Start</div>
            )}
            {state === 'ready' && (
              <div className="reaction-message">Wait for green...</div>
            )}
            {state === 'go' && (
              <div className="reaction-message">⚡ CLICK NOW! ⚡</div>
            )}
            {(state === 'result' || state === 'excellent' || state === 'good') && (
              <div className="reaction-message">
                <div className="result-time">{reactionTime}ms</div>
                <div className="result-sub">
                  {reactionTime < 200 ? '🔥 Excellent!' : reactionTime < 300 ? '👍 Good!' : '👌 Not bad!'}
                </div>
                <div className="result-sub">Click to try again</div>
              </div>
            )}
          </div>
        </div>

        <div className="game-controls">
          <Link to="/" className="btn btn-secondary">Back to Home</Link>
        </div>
      </div>
    </div>
  );
};

export default ReactionTime;
